/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../firebase";
import commentIcon from "../img/comment.svg";
import { useStateValue } from "../StateProvider";
import "./SinglePost.css";
import { format } from "timeago.js";
import Latex from "react-latex";

function SinglePost() {
  const { id } = useParams();
  const [comments, setComments] = useState([]);

  const [comment, setComment] = useState("");
  const [extractedPost, setextractedPost] = useState("");
  const [likes] = useState([]);
  const [post, setPost] = useState({});
  const [{ user }] = useStateValue();
  const icon = document.getElementById(id);

  useEffect(() => {
    document.title = `${post?.name + " " + extractedPost.split("\\(").at(0)} | Tarok.tech`;
  }, [extractedPost, post?.name]);

  useEffect(() => {
    if (id) {
      db.collection("Posts")
        .doc(id)
        .collection("Comments")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          setComments(snapshot.docs.map((doc) => doc.data()));
        });
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      db.collection("Posts")
        .doc(id)
        .get()
        .then((doc) => {
          setPost(doc.data());
          setextractedPost(extractContents(doc.data().description));
        });
    }
  }, [id]);

  useEffect(() => {
    if (id && user) {
      db.collection("Posts")
        .doc(id)
        .collection("Liked_Users")
        .doc(user.id)
        .onSnapshot((doc) => {
          try {
            if (doc.data().liked) {
              likes.push(id);
              icon.classList.add("fas");
            }
          } catch (err) {}
        });
    }
  }, [id, icon, user, likes]);
  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const postComment = (event) => {
    event.preventDefault();
    var ids = makeid(13);
    db.collection("Posts").doc(id).collection("Comments").doc(ids).set({
      comment: comment,
      commentId: ids,
      username: user.name,
      id: user.id,
      post_id: id,
      image: user.image,
      timestamp: String(new Date().getTime())
    });
    setComment("");
  };

  const changeHeart = () => {
    if (id && user) {
      icon.classList.toggle("fas");

      if (icon.classList.contains("fas")) {
        db.collection("Posts")
          .doc(id)
          .collection("Liked_Users")
          .doc(user.id)
          .set({
            liked: true,
          });
        db.collection("Posts")
          .doc(id)
          .update({
            
            liked_count: post.liked_count + 1,
          });
      } else {
        db.collection("Posts")
          .doc(id)
          .update({
            liked_count: post.liked_count - 1,
          });
        db.collection("Posts")
          .doc(id)
          .collection("Liked_Users")
          .doc(user.id)
          .delete()
          .then(function () {
            console.log("Unliked Photo!");
          })
          .catch(function (error) {
            console.error("Error unliking: ", error);
          });
      }
    }
  };
  function extractContents(ss) {
    var span = document.createElement("span");
    span.innerHTML = ss;
    try{
    ss = ss.replaceAll("<br>", "\\( \\\\ \\)");
    ss = ss.replaceAll("</p>", "\\( \\\\ \\)");
    ss = ss.replaceAll("</div>", "\\( \\\\ \\)");
    }catch(err){
      return span.textContent 
    }
    span.innerHTML = ss;
    return span.textContent || span.innerText;
  }
  return (
    post && (
      <div className="singlePostContainer">
        <div className="singlePost">
          <div className="singlePostRight">
            <div className="postHeader">
              <img className="avatar" src={post.userimage} />
              <ul className="no-bullets">
                <li>
                  {" "}
                  <Link className="commentLink" to={`/user/${post.userId}`}>
                    <h3 className="postUsername">{post.name}</h3>
                  </Link>
                </li>
                <li>
                  {" "}
                  <div className="time">{format(post.timestamp)} </div>
                </li>
              </ul>
            </div>
            <div className="postComments singlePostComments">
              <div className="postCaption">
                <Latex>{extractedPost}</Latex>
              </div>
              <img className="singlePostImage" src={post.image_url_0} />
            </div>
          </div>





          <div className="postInteractionBar">
            <i
              onClick={changeHeart}
              id={id}
              className="far fa-heart postInteractionItem postHeart"
            ></i>
            {post.liked_count}
            <Link>
              <img src={commentIcon} className="count" height={21} />
            </Link>
            {post?.comment_count}
          </div>
          {comments.map((comment, i) => (
            <dib key={i} className="commentView">
              <div className="singlePostRight">
                <div className="postHeader">
                  <img className="avatar" src={comment.image} />
                  <ul className="no-bullets">
                    <li>
                      <Link className="commentLink" to={`/user/${post.userId}`}>
                        <div className="commentLink">{comment.username}</div>
                      </Link>
                    </li>
                    <li>
                      <div className="time">{format(comment.timestamp)}</div>
                    </li>
                  </ul>
                </div>
                <div className="commentCaption">
                  <Latex>{extractContents(comment.comment)}</Latex>
                </div>
              </div>
            </dib>
          ))}
          {user ? (
            <form className="postCommentsInput">
              <input
                className="postComment"
                type="text"
                placeholder="Add a comment..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <button
                className="postCommentButton"
                type="submit"
                disabled={!comment}
                onClick={postComment}
              >
                {" "}
                Post{" "}
              </button>
            </form>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  );
}

export default SinglePost;
